export const SAVE_RAZAS_PERRO = 'SAVE_RAZAS_PERRO';
export const SAVE_RAZAS = 'SAVE_RAZAS';
export const SAVE_RAZAS_GATO = 'SAVE_RAZAS_GATO';
export const SAVE_ESTADOS_ANIMAL = 'SAVE_ESTADOS_ANIMAL';
export const SAVE_TIPOS_ENTIDAD = 'SAVE_TIPOS_ENTIDAD';
export const SAVE_EDADES_ANIMAL = 'SAVE_EDADES_ANIMAL';
export const SAVE_TAMANIOS_ANIMAL = 'SAVE_TAMANIOS_ANIMAL';
export const CHANGE_ESPECIE_SELECCIONADA = 'CHANGE_ESPECIE_SELECCIONADA';
export const CHANGE_SEXO_SELECCIONADO = 'CHANGE_SEXO_SELECCIONADO';
export const CHANGE_TAMANIOS_SELECCIONADOS = 'CHANGE_TAMANIOS_SELECCIONADOS';
export const CHANGE_EDADES_SELECCIONADAS = 'CHANGE_EDADES_SELECCIONADAS';
export const CHANGE_RAZA_SELECCIONADA = 'CHANGE_RAZA_SELECCIONADAS';
export const CHANGE_AVANZADO_FILTER = 'CHANGE_AVANZADO_FILTER';
export const CHANGE_ESTADO_SELECCIONADO = 'CHANGE_ESTADO_SELECCIONADO';
export const CHANGE_ESTADO_URGENTE_SELECCIONADO = 'CHANGE_ESTADO_URGENTE_SELECCIONADO';
export const CHANGE_COLORES_ANIMAL = 'CHANGE_COLORES_ANIMAL';
export const CHANGE_COLORES_SELECCIONADOS = 'CHANGE_COLORES_SELECCIONADOS';
export const CHANGE_CARACTERS_ANIMAL = 'CHANGE_CARACTERS_ANIMAL';
export const CHANGE_CARACTERS_SELECCIONADOS = 'CHANGE_CARACTERS_SELECCIONADOS';
export const CHANGE_CHIP_SELECCIONADO = 'CHANGE_CHIP_SELECCIONADO';
export const CHANGE_VACUNA_SELECCIONADA = 'CHANGE_VACUNA_SELECCIONADA';
export const CHANGE_PPP_SELECCIONADO = 'CHANGE_PPP_SELECCIONADO';
export const CHANGE_ENFERMEDADES_SELECCIONADO = 'CHANGE_ENFERMEDADES_SELECCIONADO';
export const CHANGE_ESTERILIZADO_SELECCIONADO = 'CHANGE_ESTERILIZADO_SELECCIONADO';
export const CHANGE_EMAIL_SUBSCRIPTION = 'CHANGE_EMAIL_SUBSCRIPTION';
export const CHANGE_POSTAL_CODE = 'CHANGE_POSTAL_CODE';
export const RESET_FILTERS = 'RESET_FILTERS';

export const SAVE_RAZAS_PERRO_PROTECTORA = 'SAVE_RAZAS_PERRO_PROTECTORA';
export const SAVE_RAZAS_PROTECTORA = 'SAVE_RAZAS_PROTECTORA';
export const SAVE_RAZAS_GATO_PROTECTORA = 'SAVE_RAZAS_GATO_PROTECTORA';
export const SAVE_ESTADOS_ANIMAL_PROTECTORA = 'SAVE_ESTADOS_ANIMAL_PROTECTORA';
export const SAVE_TIPOS_ENTIDAD_PROTECTORA = 'SAVE_TIPOS_ENTIDAD_PROTECTORA';
export const CHANGE_ESPECIE_SELECCIONADA_PROTECTORA = 'CHANGE_ESPECIE_SELECCIONADA_PROTECTORA';
export const CHANGE_SEXO_SELECCIONADO_PROTECTORA = 'CHANGE_SEXO_SELECCIONADO_PROTECTORA';
export const CHANGE_TAMANIOS_SELECCIONADOS_PROTECTORA = 'CHANGE_TAMANIOS_SELECCIONADOS_PROTECTORA';
export const CHANGE_EDADES_SELECCIONADAS_PROTECTORA = 'CHANGE_EDADES_SELECCIONADAS_PROTECTORA';
export const CHANGE_RAZA_SELECCIONADA_PROTECTORA = 'CHANGE_RAZA_SELECCIONADAS_PROTECTORA';
export const CHANGE_AVANZADO_FILTER_PROTECTORA = 'CHANGE_AVANZADO_FILTER_PROTECTORA';
export const CHANGE_ESTADO_SELECCIONADO_PROTECTORA = 'CHANGE_ESTADO_SELECCIONADO_PROTECTORA';
export const CHANGE_ESTADO_URGENTE_SELECCIONADO_PROTECTORA = 'CHANGE_ESTADO_URGENTE_SELECCIONADO_PROTECTORA';
export const CHANGE_COLORES_ANIMAL_PROTECTORA = 'CHANGE_COLORES_ANIMAL_PROTECTORA';
export const CHANGE_COLORES_SELECCIONADOS_PROTECTORA = 'CHANGE_COLORES_SELECCIONADOS_PROTECTORA';
export const CHANGE_CARACTERS_ANIMAL_PROTECTORA = 'CHANGE_CARACTERS_ANIMAL_PROTECTORA';
export const CHANGE_CARACTERS_SELECCIONADOS_PROTECTORA = 'CHANGE_CARACTERS_SELECCIONADOS_PROTECTORA';
export const CHANGE_CHIP_SELECCIONADO_PROTECTORA = 'CHANGE_CHIP_SELECCIONADO_PROTECTORA';
export const CHANGE_VACUNA_SELECCIONADA_PROTECTORA = 'CHANGE_VACUNA_SELECCIONADA_PROTECTORA';
export const CHANGE_PPP_SELECCIONADO_PROTECTORA = 'CHANGE_PPP_SELECCIONADO_PROTECTORA';
export const CHANGE_ENFERMEDADES_SELECCIONADO_PROTECTORA = 'CHANGE_ENFERMEDADES_SELECCIONADO_PROTECTORA';
export const CHANGE_ESTERILIZADO_SELECCIONADO_PROTECTORA = 'CHANGE_ESTERILIZADO_SELECCIONADO_PROTECTORA';
export const RESET_FILTERS_PROTECTORA = 'RESET_FILTERS_PROTECTORA';

export function changeEmailSubscription(email) {
    return (dispatch, getState) => {
        dispatch({type: CHANGE_EMAIL_SUBSCRIPTION, payload: {emailSubscription: email}});
    }
}

export function changePostalCode(postalCode) {
    return (dispatch, getState) => {
        dispatch({type: CHANGE_POSTAL_CODE, payload: {postalCode: postalCode}});
    }
}

export function persistSubscription(emailSubscription, filter) {
    const dataParsed = parserData({...filter, emailSubscription: emailSubscription});

    return $.ajax({
        type: "POST",
        //Datos que se envian
        data: JSON.stringify(dataParsed),
        // Formato de datos que se espera en la respuesta
        dataType: "json",
        contentType: "application/json",
        // Asincronía.
        async: false,
        // URL a la que se enviará la solicitud Ajax
        url: "/api/busqueda/suscripcionFiltro",
    })
}

function parserData(filter) {
    let dataParsed = {};
    // if (filter.razasSeleccionadas.length > 0) {
    if (filter.razaSeleccionada) {
        // let index = filter.razasSeleccionadas.findIndex(x => x === "TODAS")
        // if (index >= 0) {
        //     filter.razasSeleccionadas.splice(index, 1);
        // }
        debugger
        // dataParsed.raza = filter.razasSeleccionadas.join(",");
        dataParsed.raza = filter.razaSeleccionada;
    }
    if (filter.especieSeleccionada.length > 0) {
        dataParsed.especie = filter.especieSeleccionada;
    }
    // if (filter.razasSeleccionadas.length > 0) {
    //     dataParsed.raza = filter.razasSeleccionadas.join(",");
    // }
    if (filter.razaSeleccionada.length > 0) {
        dataParsed.raza = filter.razaSeleccionada
    }
    if (filter.sexoSeleccionado.length > 0 && filter.sexoSeleccionado !== "MH") {
        dataParsed.sexo = filter.sexoSeleccionado;
    }
    if (filter.edadesSeleccionadas.length > 0) {
        dataParsed.edad = filter.edadesSeleccionadas.join(",");
    }
    if (filter.tamaniosSeleccionados.length > 0) {
        dataParsed.tamano = filter.tamaniosSeleccionados.join(",");
    }
    dataParsed.email = filter.emailSubscription;
    dataParsed.cod_postal = filter.postalCode;
    return dataParsed
}

export function loadRaza(especie) {
    return (dispatch, getState) => {
        $.ajax({
            //Cambiar a type: POST si necesario
            type: "GET",
            // Formato de datos que se espera en la respuesta
            dataType: "json",
            // Asincronía.
            async: false,
            // URL a la que se enviará la solicitud Ajax
            url: `/api/config/animalSpecies/${especie}/`,
        })
            .done(function (data, textStatus, jqXHR) {
                const razas = {}
                razas[especie] = data
                dispatch({type: SAVE_RAZAS, payload: {razas: razas}});
                dispatch({type: SAVE_RAZAS_PROTECTORA, payload: {razas: razas}});
                // if (especie === "perro") {
                //     dispatch({type: SAVE_RAZAS_PERRO, payload: {razas: {especie:data}}});
                //     dispatch({type: SAVE_RAZAS_PERRO_PROTECTORA, payload: {razasPerro: data}});
                // } else if (especie === "gato") {
                //     dispatch({type: SAVE_RAZAS_GATO, payload: {razasGato: data}});
                //     dispatch({type: SAVE_RAZAS_GATO_PROTECTORA, payload: {razasGato: data}});
                // }
            })
            .fail(function (jqXHR, textStatus, errorThrown) {
                //console.log("jqXHR = '" + JSON.stringify(jqXHR) + "'");
                //console.log("textStatus = '" + JSON.stringify(textStatus) + "'");
                //console.log("errorThrown = '" + JSON.stringify(errorThrown) + "'");


                let errorStr;
                if (typeof jqXHR.responseJSON === "object" && jqXHR.responseJSON.error !== undefined) {
                    errorStr = jqXHR.responseJSON.error.map(err => err.msg).join(', ').replace(/,(?!.*,)/gmi, ' y')
                } else {
                    errorStr = jqXHR.responseJSON ? jqXHR.responseJSON : "Hubo un error inesperado :(";
                }

                if (console && console.log) {
                    console.log("La solicitud a fallado: " + errorStr);
                }


            });
    }
}

export function loadEstadosAnimal() {
    return (dispatch, getState) => {
        $.ajax({
            //Cambiar a type: POST si necesario
            type: "GET",
            //Datos que se envian
            data: {
                param: "estados_animal_busquedas"
            },
            // Formato de datos que se espera en la respuesta
            dataType: "json",
            // Asincronía.
            async: false,
            // URL a la que se enviará la solicitud Ajax
            url: "/api/config/params",
        })
            .done(function (data, textStatus, jqXHR) {
                dispatch({type: SAVE_ESTADOS_ANIMAL, payload: {estadosAnimal: data}});
                dispatch({type: SAVE_ESTADOS_ANIMAL_PROTECTORA, payload: {estadosAnimal: data}});
            })
            .fail(function (jqXHR, textStatus, errorThrown) {
                let errorStr;
                if (typeof jqXHR.responseJSON === "object" && jqXHR.responseJSON.error !== undefined) {
                    errorStr = jqXHR.responseJSON.error.map(err => err.msg).join(', ').replace(/,(?!.*,)/gmi, ' y')
                } else {
                    errorStr = jqXHR.responseJSON ? jqXHR.responseJSON : "Hubo un error inesperado :(";
                }

                if (console && console.log) {
                    console.log("La solicitud a fallado: " + errorStr);
                }
            });
    }
}

export function loadEdadesAnimal() {
    return (dispatch, getState) => {
        $.ajax({
            //Cambiar a type: POST si necesario
            type: "GET",
            //Datos que se envian
            data: {
                param: "edades_animal"
            },
            // Formato de datos que se espera en la respuesta
            dataType: "json",
            // Asincronía.
            async: false,
            // URL a la que se enviará la solicitud Ajax
            url: "/api/config/params",
        })
            .done(function (data, textStatus, jqXHR) {
                dispatch({type: SAVE_EDADES_ANIMAL, payload: {edadesAnimal: data}});
            })
            .fail(function (jqXHR, textStatus, errorThrown) {
                let errorStr;
                if (typeof jqXHR.responseJSON === "object" && jqXHR.responseJSON.error !== undefined) {
                    errorStr = jqXHR.responseJSON.error.map(err => err.msg).join(', ').replace(/,(?!.*,)/gmi, ' y')
                } else {
                    errorStr = jqXHR.responseJSON ? jqXHR.responseJSON : "Hubo un error inesperado :(";
                }

                if (console && console.log) {
                    console.log("La solicitud a fallado: " + errorStr);
                }
            });
    }
}

export function loadTamaniosAnimal() {
    return (dispatch, getState) => {
        $.ajax({
            //Cambiar a type: POST si necesario
            type: "GET",
            //Datos que se envian
            data: {
                param: "tamanos_animal"
            },
            // Formato de datos que se espera en la respuesta
            dataType: "json",
            // Asincronía.
            async: false,
            // URL a la que se enviará la solicitud Ajax
            url: "/api/config/params",
        })
            .done(function (data, textStatus, jqXHR) {
                dispatch({type: SAVE_TAMANIOS_ANIMAL, payload: {tamaniosAnimal: data}});
            })
            .fail(function (jqXHR, textStatus, errorThrown) {
                let errorStr;
                if (typeof jqXHR.responseJSON === "object" && jqXHR.responseJSON.error !== undefined) {
                    errorStr = jqXHR.responseJSON.error.map(err => err.msg).join(', ').replace(/,(?!.*,)/gmi, ' y')
                } else {
                    errorStr = jqXHR.responseJSON ? jqXHR.responseJSON : "Hubo un error inesperado :(";
                }

                if (console && console.log) {
                    console.log("La solicitud a fallado: " + errorStr);
                }
            });
    }
}

export function loadColoresAnimal() {
    return (dispatch, getState) => {
        $.ajax({
            //Cambiar a type: POST si necesario
            type: "GET",
            //Datos que se envian
            data: {
                param: "colores_animal"
            },
            // Formato de datos que se espera en la respuesta
            dataType: "json",
            // Asincronía.
            async: false,
            // URL a la que se enviará la solicitud Ajax
            url: "/api/config/params",
        })
            .done(function (data, textStatus, jqXHR) {
                dispatch({type: CHANGE_COLORES_ANIMAL, payload: {coloresAnimal: data}});
                dispatch({type: CHANGE_COLORES_ANIMAL_PROTECTORA, payload: {coloresAnimal: data}});
            })
            .fail(function (jqXHR, textStatus, errorThrown) {
                let errorStr;
                if (typeof jqXHR.responseJSON === "object" && jqXHR.responseJSON.error !== undefined) {
                    errorStr = jqXHR.responseJSON.error.map(err => err.msg).join(', ').replace(/,(?!.*,)/gmi, ' y')
                } else {
                    errorStr = jqXHR.responseJSON ? jqXHR.responseJSON : "Hubo un error inesperado :(";
                }

                if (console && console.log) {
                    console.log("La solicitud a fallado: " + errorStr);
                }
            });
    }
}

export function loadCaractersAnimal() {
    return (dispatch, getState) => {
        $.ajax({
            //Cambiar a type: POST si necesario
            type: "GET",
            //Datos que se envian
            data: {
                param: "caracter_animal"
            },
            // Formato de datos que se espera en la respuesta
            dataType: "json",
            // Asincronía.
            async: false,
            // URL a la que se enviará la solicitud Ajax
            url: "/api/config/params",
        })
            .done(function (data, textStatus, jqXHR) {
                dispatch({type: CHANGE_CARACTERS_ANIMAL, payload: {caractersAnimal: data}});
                dispatch({type: CHANGE_CARACTERS_ANIMAL_PROTECTORA, payload: {caractersAnimal: data}});
            })
            .fail(function (jqXHR, textStatus, errorThrown) {
                let errorStr;
                if (typeof jqXHR.responseJSON === "object" && jqXHR.responseJSON.error !== undefined) {
                    errorStr = jqXHR.responseJSON.error.map(err => err.msg).join(', ').replace(/,(?!.*,)/gmi, ' y')
                } else {
                    errorStr = jqXHR.responseJSON ? jqXHR.responseJSON : "Hubo un error inesperado :(";
                }

                if (console && console.log) {
                    console.log("La solicitud a fallado: " + errorStr);
                }
            });
    }
}


export function loadTiposEntidad() {
    return (dispatch, getState) => {
        $.ajax({
            //Cambiar a type: POST si necesario
            type: "GET",
            //Datos que se envian
            data: {
                param: "tipos_entidad"
            },
            // Formato de datos que se espera en la respuesta
            dataType: "json",
            // Asincronía.
            async: false,
            // URL a la que se enviará la solicitud Ajax
            url: "/api/config/params",
        })
            .done(function (data, textStatus, jqXHR) {
                // dispatch({type: SAVE_ESTADOS_ANIMAL, payload: {estadosAnimal: data}});
                dispatch({type: SAVE_TIPOS_ENTIDAD, payload: {tiposEntidad: data}});
                // dispatch({type: SAVE_ESTADOS_ANIMAL_PROTECTORA, payload: {estadosAnimal: data}});
                dispatch({type: SAVE_TIPOS_ENTIDAD_PROTECTORA, payload: {tiposEntidad: data}});
            })
            .fail(function (jqXHR, textStatus, errorThrown) {
                let errorStr;
                if (typeof jqXHR.responseJSON === "object" && jqXHR.responseJSON.error !== undefined) {
                    errorStr = jqXHR.responseJSON.error.map(err => err.msg).join(', ').replace(/,(?!.*,)/gmi, ' y')
                } else {
                    errorStr = jqXHR.responseJSON ? jqXHR.responseJSON : "Hubo un error inesperado :(";
                }

                if (console && console.log) {
                    console.log("La solicitud a fallado: " + errorStr);
                }
            });
    }
}


export function changeEspecieSeleccionada(especie, filter) {
    console.log("changeEspecieSeleccionada::changeEspecieSeleccionada() -> " + filter);
    return (dispatch, getState) => {
        if (filter === "filtersControl") {
            dispatch({type: CHANGE_ESPECIE_SELECCIONADA, payload: {especieSeleccionada: especie}});
        } else if (filter === "filtersControlProtectora") {
            dispatch({type: CHANGE_ESPECIE_SELECCIONADA_PROTECTORA, payload: {especieSeleccionada: especie}});
        }
    }
}

export function changeSexoSeleccionado(sexo, filter) {
    return (dispatch, getState) => {
        if (filter === "filtersControl") {
            dispatch({type: CHANGE_SEXO_SELECCIONADO, payload: {sexoSeleccionado: sexo}});
        } else if (filter === "filtersControlProtectora") {
            dispatch({type: CHANGE_SEXO_SELECCIONADO_PROTECTORA, payload: {sexoSeleccionado: sexo}});
        }
    }
}

export function changeTamaniosSeleccionado(tamanio, filter) {
    return (dispatch, getState) => {
        let tamaniosSeleccionados = [];

debugger
        if (filter === "filtersControl") {
            tamaniosSeleccionados = getState().filtersControl.tamaniosSeleccionados;
        } else if (filter === "filtersControlProtectora") {
            tamaniosSeleccionados = getState().filtersControlProtectora.tamaniosSeleccionados;
        }


        let index = tamaniosSeleccionados.indexOf(tamanio);

        if (index === -1) {
            tamaniosSeleccionados.push(tamanio);
        } else {
            tamaniosSeleccionados.splice(index, 1);
        }

        if (filter === "filtersControl") {
            dispatch({type: CHANGE_TAMANIOS_SELECCIONADOS, payload: {tamaniosSeleccionados: tamaniosSeleccionados}});
        } else if (filter === "filtersControlProtectora") {
            dispatch({
                type: CHANGE_TAMANIOS_SELECCIONADOS_PROTECTORA,
                payload: {tamaniosSeleccionados: tamaniosSeleccionados}
            });
        }
    }
}
export function resetTamaniosSeleccionado(filter) {
    return (dispatch, getState) => {
        let tamaniosSeleccionados = [];

        if (filter === "filtersControl") {
            dispatch({type: CHANGE_TAMANIOS_SELECCIONADOS, payload: {tamaniosSeleccionados: tamaniosSeleccionados}});
        } else if (filter === "filtersControlProtectora") {
            dispatch({
                type: CHANGE_TAMANIOS_SELECCIONADOS_PROTECTORA,
                payload: {tamaniosSeleccionados: tamaniosSeleccionados}
            });
        }
    }
}

export function changeEdadesSeleccionado(edad, filter) {
    return (dispatch, getState) => {
        let edadesSeleccionadas = [];
        if (filter === "filtersControl") {
            edadesSeleccionadas = getState().filtersControl.edadesSeleccionadas;
        } else if (filter === "filtersControlProtectora") {
            edadesSeleccionadas = getState().filtersControlProtectora.edadesSeleccionadas;
        }
        let index = edadesSeleccionadas.indexOf(edad);
        if (index === -1) {
            edadesSeleccionadas.push(edad);
        } else {
            edadesSeleccionadas.splice(index, 1);
        }
        if (filter === "filtersControl") {
            dispatch({type: CHANGE_EDADES_SELECCIONADAS, payload: {edadesSeleccionadas: edadesSeleccionadas}});
        } else if (filter === "filtersControlProtectora") {
            dispatch({
                type: CHANGE_EDADES_SELECCIONADAS_PROTECTORA,
                payload: {edadesSeleccionadas: edadesSeleccionadas}
            });
        }
    }
}

//
// export function changeRazasSeleccionadas(razas, filter, param) {
//     // console.log("changeRazasSeleccionadas::changeRazasSeleccionadas() --> " + param);
//     return (dispatch, getState) => {
//         debugger
//         if (filter === "filtersControl") {
//             dispatch({type: CHANGE_RAZA_SELECCIONADA, payload: {razasSeleccionadas: razas}});
//         } else if (filter === "filtersControlProtectora") {
//             dispatch({type: CHANGE_RAZA_SELECCIONADA_PROTECTORA, payload: {razasSeleccionadas: razas}});
//         }
//     }
// }
export function changeRazaSeleccionada(raza, filter, param) {
    // console.log("actionsFilter::changeRazaSeleccionada() --> " + param);
    return (dispatch, getState) => {
        if (filter === "filtersControl") {
            dispatch({type: CHANGE_RAZA_SELECCIONADA, payload: {razaSeleccionada: raza}});
        } else if (filter === "filtersControlProtectora") {
            dispatch({type: CHANGE_RAZA_SELECCIONADA_PROTECTORA, payload: {razaSeleccionada: raza}});
        }
    }
}

export function changeAvanzadoFilter(filter) {
    return (dispatch, getState) => {
        if (filter === "filtersControl") {
            dispatch({type: CHANGE_AVANZADO_FILTER, payload: {avanzado: !getState().filtersControl.avanzado}});
        } else if (filter === "filtersControlProtectora") {
            dispatch({
                type: CHANGE_AVANZADO_FILTER_PROTECTORA,
                payload: {avanzado: !getState().filtersControlProtectora.avanzado}
            });
        }
    }
}

export function changeEstadoSeleccionado(estado, filter) {
    // console.log("changeEstadoSeleccionado::changeEstadoSeleccionado() -> " + filter);
    return (dispatch, getState) => {
        if (filter === "filtersControlProtectora") {
            dispatch({type: CHANGE_ESTADO_SELECCIONADO_PROTECTORA, payload: {estadoAnimalSeleccionado: estado}});
        }
    }
}

export function changeColoresAnimal(colores, filter) {
    return (dispatch, getState) => {
        if (filter === "filtersControl") {
            dispatch({type: CHANGE_COLORES_ANIMAL, payload: {coloresAnimal: colores}});
        } else if (filter === "filtersControlProtectora") {
            dispatch({type: CHANGE_COLORES_ANIMAL_PROTECTORA, payload: {coloresAnimal: colores}});
        }
    }
}

export function changeColoresAnimalSeleccionados(colores, filter) {
    return (dispatch, getState) => {
        if (filter === "filtersControl") {
            dispatch({type: CHANGE_COLORES_SELECCIONADOS, payload: {coloresAnimalSeleccionados: colores}});
        } else if (filter === "filtersControlProtectora") {
            dispatch({type: CHANGE_COLORES_SELECCIONADOS_PROTECTORA, payload: {coloresAnimalSeleccionados: colores}});
        }
    }
}

export function changeCaractersAnimal(caracters, filter) {
    return (dispatch, getState) => {
        if (filter === "filtersControl") {
            dispatch({type: CHANGE_CARACTERS_ANIMAL, payload: {caractersAnimal: caracters}});
        } else if (filter === "filtersControlProtectora") {
            dispatch({type: CHANGE_CARACTERS_ANIMAL_PROTECTORA, payload: {caractersAnimal: caracters}});
        }
    }
}

export function changeCaractersAnimalSeleccionados(caracters, filter) {
    return (dispatch, getState) => {
        if (filter === "filtersControl") {
            dispatch({type: CHANGE_CARACTERS_SELECCIONADOS, payload: {caractersAnimalSeleccionados: caracters}});
        } else if (filter === "filtersControlProtectora") {
            dispatch({
                type: CHANGE_CARACTERS_SELECCIONADOS_PROTECTORA,
                payload: {caractersAnimalSeleccionados: caracters}
            });
        }
    }
}

export function changeEstadoUrgenteSeleccionado(estadoUrgente, filter) {
    return (dispatch) => {
        if (filter === "filtersControl") {
            dispatch({type: CHANGE_ESTADO_URGENTE_SELECCIONADO, payload: {estadoUrgenteSeleccionado: estadoUrgente}});
        } else if (filter === "filtersControlProtectora") {
            dispatch({
                type: CHANGE_ESTADO_URGENTE_SELECCIONADO_PROTECTORA,
                payload: {estadoUrgenteSeleccionado: estadoUrgente}
            });
        }
    }
}

export function changeChipSeleccionado(chip, filter) {
    return (dispatch, getState) => {
        if (filter === "filtersControl") {
            dispatch({type: CHANGE_CHIP_SELECCIONADO, payload: {chipSeleccionado: chip}});
        } else if (filter === "filtersControlProtectora") {
            dispatch({type: CHANGE_CHIP_SELECCIONADO_PROTECTORA, payload: {chipSeleccionado: chip}});
        }
    }
}

export function changeVacunaSeleccionada(vacuna, filter) {
    return (dispatch, getState) => {
        if (filter === "filtersControl") {
            dispatch({type: CHANGE_VACUNA_SELECCIONADA, payload: {vacunaSeleccionada: vacuna}});
        } else if (filter === "filtersControlProtectora") {
            dispatch({type: CHANGE_VACUNA_SELECCIONADA_PROTECTORA, payload: {vacunaSeleccionada: vacuna}});
        }
    }
}

export function changePPPSeleccionado(ppp, filter) {
    return (dispatch, getState) => {
        if (filter === "filtersControl") {
            dispatch({type: CHANGE_PPP_SELECCIONADO, payload: {pppSeleccionado: ppp}});
        } else if (filter === "filtersControlProtectora") {
            dispatch({type: CHANGE_PPP_SELECCIONADO_PROTECTORA, payload: {pppSeleccionado: ppp}});
        }
    }
}

export function changeEnfermedadesSeleccionado(enfermedades, filter) {
    return (dispatch, getState) => {
        if (filter === "filtersControl") {
            dispatch({type: CHANGE_ENFERMEDADES_SELECCIONADO, payload: {enfermedadesSeleccionado: enfermedades}});
        } else if (filter === "filtersControlProtectora") {
            dispatch({
                type: CHANGE_ENFERMEDADES_SELECCIONADO_PROTECTORA,
                payload: {enfermedadesSeleccionado: enfermedades}
            });
        }
    }
}

export function changeEsterilizadoSeleccionado(esterilizado, filter) {
    return (dispatch, getState) => {
        if (filter === "filtersControl") {
            dispatch({type: CHANGE_ESTERILIZADO_SELECCIONADO, payload: {esterilizadoSeleccionado: esterilizado}});
        } else if (filter === "filtersControlProtectora") {
            dispatch({
                type: CHANGE_ESTERILIZADO_SELECCIONADO_PROTECTORA,
                payload: {esterilizadoSeleccionado: esterilizado}
            });
        }
    }
}

export function resetFilters(filter) {
    return (dispatch, getState) => {
        if (filter === "filtersControl") {
            dispatch({type: RESET_FILTERS, payload: {}});
        } else if (filter === "filtersControlProtectora") {
            dispatch({type: RESET_FILTERS_PROTECTORA, payload: {}});
        }
    }
}